import StepByStep from "screens/lead/components/cardOportunidades/components/StepByStep/stepbystep.component";
import {
  RiUserLine,
  RiTeamLine,
  RiFileList3Line,
  RiFileExcel2Fill,
} from "react-icons/ri";
import { TbCopyright } from "react-icons/tb";
import { Tooltip } from "@mui/material";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { obterNomeEtapaExibicao } from "utils/obterNomeEtapaExibicao";
import * as S from "./styles";
import { badgeColors } from "./colors";

interface Data {
  dataDetalheOportunidade: any;
}

const TableProduct = (data: Data) => {
  const { usuarioVivaz } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const generateBadgeColor = () => {
    return (
      badgeColors[data?.dataDetalheOportunidade?.nomeSubEtapa?.toLowerCase()] ||
      "#a3a3a6"
    );
  };
  return (
    <S.Content>
      <S.Header>
        <S.TextHeader className="col-1">Empreendimento</S.TextHeader>
        <S.TextHeader className="col-2">ID Proposta</S.TextHeader>
        <S.TextHeader className="col-3">Ficha n°</S.TextHeader>
        <S.TextHeader className="col-4">Etapa</S.TextHeader>
      </S.Header>
      <S.Body>
        <S.BodyItems>
          <S.Row className="col-1">
            <S.TableImage
              src={data?.dataDetalheOportunidade?.urlImagemEmpreendimento}
              alt="Imagem"
            />
            <S.Column>
              <S.TextProduct>
                {data?.dataDetalheOportunidade?.nomeEmpreendimento || "--"}
              </S.TextProduct>
              <S.TextBlocoUnidade>
                Bloco: {data?.dataDetalheOportunidade?.bloco || "--"}
              </S.TextBlocoUnidade>
              <S.TextBlocoUnidade>
                Unidade: {data?.dataDetalheOportunidade?.unidade || "--"}
              </S.TextBlocoUnidade>
              {data?.dataDetalheOportunidade?.propostaManual ? (
                <>
                  <S.SpaceY space={6} />
                  <S.BadgePropostaManual>
                    <RiFileExcel2Fill size={14} color="#4CAF50" />
                    <S.TextPropostaManual>Proposta Manual</S.TextPropostaManual>
                  </S.BadgePropostaManual>
                </>
              ) : null}
            </S.Column>
          </S.Row>
          <S.Row className="col-2">
            <S.TextCOT>
              {data?.dataDetalheOportunidade?.numeroCotacao || "--"}
            </S.TextCOT>
          </S.Row>
          <S.Row className="col-3">
            <S.TextFicha>
              {data?.dataDetalheOportunidade?.numeroFicha || "--"}
            </S.TextFicha>
          </S.Row>
          <S.Row className="col-4">
            <S.PositionContainer>
              <S.TextEtapa>
                {data?.dataDetalheOportunidade?.nomeEtapa || "--"}
              </S.TextEtapa>
              {data?.dataDetalheOportunidade?.nomeSubEtapa ? (
                <S.TextSimulation color={generateBadgeColor}>
                  {obterNomeEtapaExibicao(
                    data?.dataDetalheOportunidade?.nomeSubEtapa,
                    usuarioVivaz
                  ) || "--"}
                </S.TextSimulation>
              ) : null}
            </S.PositionContainer>
          </S.Row>
        </S.BodyItems>

        <S.SpaceY space={48} />

        {/* Informações do Lead em linha compacta */}
        <S.LeadInfoRow>
          <Tooltip arrow title={data?.dataDetalheOportunidade?.nomeLead || ""}>
            <S.LeadInfoItemCompact>
              <RiUserLine size={16} color="#666" />
              <S.LeadInfoText>
                <S.LeadInfoLabelSmall>Lead</S.LeadInfoLabelSmall>
                <S.LeadInfoValueSmall>
                  {data?.dataDetalheOportunidade?.nomeLead || "--"}
                </S.LeadInfoValueSmall>
              </S.LeadInfoText>
            </S.LeadInfoItemCompact>
          </Tooltip>

          <Tooltip
            arrow
            title={data?.dataDetalheOportunidade?.codigoLead || ""}
          >
            <S.LeadInfoItemCompact>
              <RiFileList3Line size={16} color="#666" />
              <S.LeadInfoText>
                <S.LeadInfoLabelSmall>Código</S.LeadInfoLabelSmall>
                <S.LeadInfoValueSmall>
                  {data?.dataDetalheOportunidade?.codigoLead || "--"}
                </S.LeadInfoValueSmall>
              </S.LeadInfoText>
            </S.LeadInfoItemCompact>
          </Tooltip>

          <Tooltip
            arrow
            title={data?.dataDetalheOportunidade?.nomeCorretor || ""}
          >
            <S.LeadInfoItemCompact>
              <RiUserLine size={16} color="#666" />
              <S.LeadInfoText>
                <S.LeadInfoLabelSmall>Corretor</S.LeadInfoLabelSmall>
                <S.LeadInfoValueSmall>
                  {data?.dataDetalheOportunidade?.nomeCorretor || "--"}
                </S.LeadInfoValueSmall>
              </S.LeadInfoText>
            </S.LeadInfoItemCompact>
          </Tooltip>

          <Tooltip arrow title={data?.dataDetalheOportunidade?.equipe || ""}>
            <S.LeadInfoItemCompact>
              <RiTeamLine size={16} color="#666" />
              <S.LeadInfoText>
                <S.LeadInfoLabelSmall>Equipe</S.LeadInfoLabelSmall>
                <S.LeadInfoValueSmall>
                  {data?.dataDetalheOportunidade?.equipe || "--"}
                </S.LeadInfoValueSmall>
              </S.LeadInfoText>
            </S.LeadInfoItemCompact>
          </Tooltip>

          <Tooltip
            arrow
            title={data?.dataDetalheOportunidade?.imobiliaria || ""}
          >
            <S.LeadInfoItemCompact>
              <TbCopyright size={16} color="#666" />
              <S.LeadInfoText>
                <S.LeadInfoLabelSmall>Imobiliária</S.LeadInfoLabelSmall>
                <S.LeadInfoValueSmall>
                  {data?.dataDetalheOportunidade?.imobiliaria || "--"}
                </S.LeadInfoValueSmall>
              </S.LeadInfoText>
            </S.LeadInfoItemCompact>
          </Tooltip>
          <Tooltip
            arrow
            title={data?.dataDetalheOportunidade?.compartilhado || ""}
          >
            <S.LeadInfoItemCompact>
              <TbCopyright size={16} color="#666" />
              <S.LeadInfoText>
                <S.LeadInfoLabelSmall>Compartilhado com</S.LeadInfoLabelSmall>
                <S.LeadInfoValueSmall>
                  {data?.dataDetalheOportunidade?.compartilhado || "--"}
                </S.LeadInfoValueSmall>
              </S.LeadInfoText>
            </S.LeadInfoItemCompact>
          </Tooltip>
        </S.LeadInfoRow>

        <StepByStep
          steps={data?.dataDetalheOportunidade?.listaEtapas?.etapas || []}
          etapasPendencias={data?.dataDetalheOportunidade?.etapasPendencias}
        />
      </S.Body>
    </S.Content>
  );
};

export default TableProduct;
